import Lookup from 'src/componentes/select2';

const StatusPerdaOperacional = ({...rest}) => {
  return(
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusPerdaOperacionalLookup"
      {...rest}
    />
  )
}

export default StatusPerdaOperacional;
